var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "popup_wrap" }, [
      _c("div", { staticClass: "print_content" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }